import { buildQueryString } from "./buildQueryString";

describe("buildQueryString", () => {
    it("creates a query string with url encoded parameter values", () => {
        expect(
            buildQueryString({
                umlauteChars: "Äéß",
                specialChars: "?!<>&=",
                intNumber: 100,
                floatNumber: 99.999,
                trueBoolean: true,
                falseBoolean: false
            })
        ).toEqual(
            /* eslint-disable-next-line max-len */
            "umlauteChars=%C3%84%C3%A9%C3%9F&specialChars=%3F!%3C%3E%26%3D&intNumber=100&floatNumber=99.999&trueBoolean=true&falseBoolean=false"
        );
    });

    it("creates a query string with url encoded parameter names", () => {
        expect(
            buildQueryString({
                "key with spaces": 1,
                "key with <!?=": 1
            })
        ).toEqual("key%20with%20spaces=1&key%20with%20%3C!%3F%3D=1");
    });

    it("can handle empty data", () => {
        expect(buildQueryString({})).toEqual("");
    });
});
